import { HVSubstationSetupErrorCode } from "../enums/ErrorCodes";
import { Address } from "./Address";
import { SurveyableAsset } from "./SurveyableAsset";
import { mapHvSurveyableAssetFromAsset } from "./SurveyableAsset";

export interface HvSubstation {
  id?: number;
  name: string;
  customerId?: number;
  locationId?: number;
  code?: string;
  address?: Address;
  latitude?: number;
  longitude?: number;
  osGridReference?: string;
  company?: string;
  site?: string;
  licenceArea?: string;
  district?: string;
  switchGears?: SurveyableAsset[];
  accessNotes?: string;
}

export interface HvSubstationSubmission {
  customerId?: number;
  hvSubstation: Partial<HvSubstation>;
}

export interface HvSubstation2Submission extends HvSubstation {
  customerId?: number;
  substationId?: number;
  surveyableAssets?: SurveyableAsset[];
}

export interface HvSubstationErrorResponse {
  errorCode: HVSubstationSetupErrorCode;
  affectedIds: number[];
  errorMessage: string;
}

export const CreateHvSubstationPayload = (submission: HvSubstation2Submission) => {
  const {
    substationId,
    customerId,
    code,
    latitude,
    longitude,
    osGridReference,
    name,
    locationId,
    address,
    company,
    site,
    licenceArea,
    district,
    accessNotes,
    surveyableAssets,
  } = submission;

  return {
    substationId,
    customerId,
    latitude,
    longitude,
    osGridReference,
    name,
    locationId,
    code,
    address,
    company,
    site,
    licenceArea,
    district,
    accessNotes,
    surveyableAssets: surveyableAssets?.map(mapHvSurveyableAssetFromAsset),
  };
};
